import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import useUpdate from "../../api/useUpdate";
import { useTranslation } from "react-i18next";

const AgentEdit = ({ agent, open, onClose, token, onSuccess }) => {
  const { t } = useTranslation();
  const { handleUpdate, loading, isSuccess } = useUpdate("shop/customers", token);
  const [agentType, setAgentType] = useState("customer");
  const [name, setName] = useState("");
  const [number, setNumber] = useState("");
  const [address, setAddress] = useState("");

  useEffect(() => {
    if (!agent) return;
    setAgentType(agent.agent_type || "customer");
    setName(agent.name || "");
    setNumber(agent.contact || "");
    setAddress(agent.address || "");
  }, [agent]);

  useEffect(() => {
    if (!isSuccess) return;
    onSuccess?.();
    onClose();
  }, [isSuccess, onClose, onSuccess]);

  const handleSubmit = () => {
    if (!agent?.id || !name.trim()) return;

    const formData = new FormData();
    formData.append("agent_type", agentType);
    formData.append("name", name.trim());
    formData.append("contact", number.trim());
    formData.append("address", address.trim());

    handleUpdate(agent.id, formData);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{t("agent.editAgentTitle", "Edit Agent")}</DialogTitle>
      <DialogContent>
        <Box component="form" noValidate sx={{ mt: 1 }}>
          <TextField
            autoFocus
            margin="dense"
            label={t("agent.name", "Agent Name")}
            type="text"
            fullWidth
            required
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
          <TextField
            margin="dense"
            label={t("agent.number", "Agent Number")}
            type="text"
            fullWidth
            value={number}
            onChange={(event) => setNumber(event.target.value)}
          />
          <TextField
            margin="dense"
            label={t("agent.address", "Agent Address")}
            type="text"
            fullWidth
            multiline
            rows={3}
            value={address}
            onChange={(event) => setAddress(event.target.value)}
          />
          <FormControl fullWidth margin="dense" required>
            <InputLabel id="edit-agent-type-label">{t("agent.agentType", "Type")}</InputLabel>
            <Select
              labelId="edit-agent-type-label"
              label={t("agent.agentType", "Type")}
              value={agentType}
              onChange={(event) => setAgentType(event.target.value)}
            >
              <MenuItem value="customer">{t("agent.customer", "Customer")}</MenuItem>
              <MenuItem value="supplier">{t("agent.supplier", "Supplier")}</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" disabled={loading}>
          {t("agent.cancel", "Cancel")}
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          sx={{ minWidth: 100 }}
          disabled={loading || !name.trim()}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : t("agent.update", "Update")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AgentEdit;
